/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */

import { count } from 'console';
import { text } from 'stream/consumers';
import { BASE_URL_API } from '../constants/constants';

/* eslint-disable no-undef */
export const truncateString = (str: string, num: number): string => {
  if (str.length <= num) {
    return str;
  }

  return `${str.slice(0, num - 3)}...`;
};

class APIError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

function checkResponse(res: any): Promise<any> {
  if (res.ok) {
    return res.json();
  }
  return res.json().then((error: any) => {
    console.log(error);
    throw new Error(error.message || 'Something went wrong');
  });
}
export function request(endpoint: string, options?: RequestInit): Promise<any> {
  const url = `${BASE_URL_API}${endpoint}`;
  return fetch(url, options).then(checkResponse);
}

export function timeSinceLastOnline(lastOnline: number): {
  text: string;
  count: number;
} {
  const currentTime = Math.floor(Date.now() / 1000);
  const diffInSeconds = currentTime - lastOnline;
  const days = Math.ceil(diffInSeconds / 86400);

  if (days === 1) {
    return {
      text: 'сегодня',
      count: days,
    };
  }
  if (days < 4) {
    return {
      text: `${days} дня назад`,
      count: days,
    };
  }
  return {
    text: `${days} дней назад`,
    count: days,
  };
}
